// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LocalOffer: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M40.6,20.12L21.85,1.38c-0.75-0.75-1.79-1.21-2.94-1.21H4.33
	c-2.29,0-4.17,1.88-4.17,4.17v14.58c0,1.15,0.46,2.19,1.23,2.96l18.75,18.75c0.75,0.75,1.79,1.21,2.94,1.21
	c1.15,0,2.19-0.46,2.94-1.23L40.6,26.02c0.77-0.75,1.23-1.79,1.23-2.94C41.83,21.94,41.35,20.88,40.6,20.12z M7.46,10.58
	c-1.73,0-3.12-1.4-3.12-3.12c0-1.73,1.4-3.12,3.12-3.12c1.73,0,3.12,1.4,3.12,3.12C10.58,9.19,9.19,10.58,7.46,10.58z"/>
</svg>;
};

export default React.memo(LocalOffer);
